<template>

    <div id="result-chart-co2-container" class="table-container relative">
        <AxiosOverlayer :loading="axiosCall" :position-class="'absolute'"/>
        <template v-if=" descriptions.value">
        <h2>Erläuterungen</h2>
        <template v-for="(section, sectionsKey) in descriptions.value.items">
            <div :id="'section-' + sectionsKey" class="table-section-wrapper" :class="['section',activeSection == sectionsKey ? 'active-section' :'', section.template ? 'template-' + section.template : '']">
                <div class="table-wrapper section-header relative z-20 cursor-pointer" @click="toggleTableContent(sectionsKey)">
                    <table class="result-table" border="0" cellspacing="0" cellpadding="0">
                        <tr class="section-main-header">
                            <td>
                                <div class="result-table-cell lining-nums tabular-nums text-left font-bold">
                                    {{ section.title}}
                                </div>
                            </td>
                        </tr>
                    </table>
                    <div class="w-10 h-10 absolute right-2 top-5 p-1 cursor-pointer" >
                        <Icon :name="'chevron-' + (sectionsKey == activeSection ? 'up' : 'down')" :height="8" :width="8"/>
                    </div>
                </div>
                <div class="table-wrapper section-result relative z-10 pb-2">
                    <div class="overflow-hidden pb-4">
                        <table class="result-table -mb-6" border="0" cellspacing="0" cellpadding="0" :class="['section-' + sectionsKey,'section',activeSection == sectionsKey ? 'active-section' :'']">
                            <thead>
                            <tr>
                                <td>
                                    <div class="p-4 text-left section-content" v-html="section.content"></div></td>
                            </tr>
                            </thead>
                        </table>
                    </div>
                </div>
            </div>
        </template>
        </template>
    </div>
</template>

<script>
import {ref, computed, getCurrentInstance, onBeforeMount, reactive, nextTick} from 'vue'
import {API} from "@/utils/api";
import {useStore} from "vuex";

export default {
    props: {
        houseState: {
            type: String,
            required: false,
            default: ''
        }
    },
    setup(props) {

        const houseState = props.houseState;
        const store = useStore();
        const axiosCall = ref(false);
        const internalInstance = getCurrentInstance();
        const emitter = internalInstance.appContext.config.globalProperties.$emitter;
        const descriptions = reactive({})

        onBeforeMount(() => {

            (async () => {

                axiosCall.value = true;
                await nextTick();
                await API.get('user').then((response) => {
                    store.dispatch('Customer/setUser', response.data)
                }).catch((error) => {
                    store.dispatch('Customer/logout')
                })

                await API.get('getDescriptions/' + houseState).then((resp) => {
                    axiosCall.value = false;
                    console.log(resp.data)
                    descriptions.value = resp.data;

                }).catch(err => {
                    axiosCall.value = false
                    console.error(err)
                    console.log(err.response)
                    emitter.emit("flash-message", {
                        text: err.response.data.message,
                        type: 'error'
                    })
                    router.push('/projects');
                })

                axiosCall.value = false;
            })()
        })
        const activeSection = ref(-1);

        const toggleTableContent = async (sectionsKey) => {
            activeSection.value == sectionsKey ? activeSection.value = -1 : activeSection.value = sectionsKey;
            await nextTick();
            if(activeSection.value != -1){
                scrollTo({
                    top: getOffset(document.getElementById('section-'+activeSection.value)).top - 110,
                    left: 0
                });
            }
        }

        const getOffset = (el) => {
            var rect = el.getBoundingClientRect(),
                scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
                scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            return {top: rect.top + scrollTop, left: rect.left + scrollLeft}
        }


        return {
            axiosCall,
            descriptions,
            activeSection,
            toggleTableContent
        }
    }
}

</script>

<style lang="scss" >

.template-abkuerzungsverzeichnis{

    .section-content {

        table{

            td {
                width: 80%;
                border: 1px solid #e5e7eb;
                padding: 5px;

                &.col-first{
                    width: 20%;
                }
            }

        }
    }

}
.section-content {
    ul{
        list-style: disc;
        padding-left: 20px;
    }
    .notes{
        font-size: 10px;
    }
    ul,p{
        margin-bottom: 20px;
    }
    table{

        td {

            border: 1px solid #e5e7eb;
            padding: 5px;

            &:first-child{

            }
            p{
                margin-bottom: 0px;
            }
        }
        td.head{
            background-color: #576874;
            color: white;
        }
        margin-bottom: 20px;

    }
}
</style>
